import {
  createCategory as publicCreateCategory,
  updateCategory as publicUpdateCategory,
  getCategory as publicGetCategory,
  getCategoryBySlug as publicGetCategoryBySlug,
  listCategories as publicListCategories,
  queryCategories as publicQueryCategories,
  typedQueryCategories as publicTypedQueryCategories,
  deleteCategory as publicDeleteCategory,
} from './blog-v3-category-categories.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { HttpClient } from '@wix/sdk-types';
import { createQueryOverloadRouter } from '@wix/sdk-runtime/query-method-router';
import {
  CategoriesQueryBuilder,
  CategoryQuery,
  QueryCategoriesOptions,
  typedQueryCategories as universalTypedQueryCategories,
} from './blog-v3-category-categories.universal.js';
import { onCategoryCreated as publicOnCategoryCreated } from './blog-v3-category-categories.public.js';
import { onCategoryDeleted as publicOnCategoryDeleted } from './blog-v3-category-categories.public.js';
import { onCategoryUpdated as publicOnCategoryUpdated } from './blog-v3-category-categories.public.js';

function customQueryCategories(httpClient: HttpClient) {
  const router = createQueryOverloadRouter({
    builderQueryFunction: (options?: QueryCategoriesOptions) =>
      publicQueryCategories(httpClient)(options),
    typedQueryFunction: (
      query: CategoryQuery,
      options?: QueryCategoriesOptions
    ) => publicTypedQueryCategories(httpClient)(query, options),
    hasOptionsParameter: true,
  });

  function overloadedQuery(
    query: CategoryQuery,
    options?: QueryCategoriesOptions
  ): ReturnType<typeof universalTypedQueryCategories>;
  function overloadedQuery(
    options?: QueryCategoriesOptions
  ): CategoriesQueryBuilder;
  function overloadedQuery(
    queryOrOptions?: CategoryQuery | QueryCategoriesOptions,
    options?: QueryCategoriesOptions
  ): any {
    return router(...arguments);
  }

  return overloadedQuery;
}

export const createCategory: MaybeContext<
  BuildRESTFunction<typeof publicCreateCategory> & typeof publicCreateCategory
> = /*#__PURE__*/ createRESTModule(publicCreateCategory);
export const updateCategory: MaybeContext<
  BuildRESTFunction<typeof publicUpdateCategory> & typeof publicUpdateCategory
> = /*#__PURE__*/ createRESTModule(publicUpdateCategory);
export const getCategory: MaybeContext<
  BuildRESTFunction<typeof publicGetCategory> & typeof publicGetCategory
> = /*#__PURE__*/ createRESTModule(publicGetCategory);
export const getCategoryBySlug: MaybeContext<
  BuildRESTFunction<typeof publicGetCategoryBySlug> &
    typeof publicGetCategoryBySlug
> = /*#__PURE__*/ createRESTModule(publicGetCategoryBySlug);
export const listCategories: MaybeContext<
  BuildRESTFunction<typeof publicListCategories> & typeof publicListCategories
> = /*#__PURE__*/ createRESTModule(publicListCategories);
export const deleteCategory: MaybeContext<
  BuildRESTFunction<typeof publicDeleteCategory> & typeof publicDeleteCategory
> = /*#__PURE__*/ createRESTModule(publicDeleteCategory);
export const queryCategories: MaybeContext<
  BuildRESTFunction<typeof customQueryCategories> & typeof customQueryCategories
> = /*#__PURE__*/ createRESTModule(customQueryCategories);
/**
 * Triggered when a category is created.
 */
export const onCategoryCreated: BuildEventDefinition<
  typeof publicOnCategoryCreated
> &
  typeof publicOnCategoryCreated = createEventModule(publicOnCategoryCreated);
/**
 * Triggered when a category is deleted.
 */
export const onCategoryDeleted: BuildEventDefinition<
  typeof publicOnCategoryDeleted
> &
  typeof publicOnCategoryDeleted = createEventModule(publicOnCategoryDeleted);
/**
 * Triggered when a category is updated.
 */
export const onCategoryUpdated: BuildEventDefinition<
  typeof publicOnCategoryUpdated
> &
  typeof publicOnCategoryUpdated = createEventModule(publicOnCategoryUpdated);

export {
  Field,
  SortOrder,
  WebhookIdentityType,
} from './blog-v3-category-categories.universal.js';
export {
  Category,
  SeoSchema,
  Keyword,
  Tag,
  Settings,
  FocalPoint,
  CategoryTranslation,
  InitialCategoriesCopied,
  CreateCategoryRequest,
  CreateCategoryResponse,
  BulkCreateCategoriesRequest,
  BulkCreateCategoriesResponse,
  BulkCategoryResult,
  ItemMetadata,
  ApplicationError,
  BulkActionMetadata,
  BulkUpdateCategoriesRequest,
  MaskedCategory,
  BulkUpdateCategoriesResponse,
  UpdateCategoryRequest,
  UpdateCategoryResponse,
  GetCategoriesCountByLanguageRequest,
  GetCategoriesCountByLanguageResponse,
  CategoryLanguageCount,
  GetCategoryRequest,
  GetCategoryResponse,
  GetCategoryBySlugRequest,
  GetCategoryBySlugResponse,
  ListCategoriesRequest,
  BlogPaging,
  ListCategoriesResponse,
  MetaData,
  QueryCategoriesRequest,
  PlatformQuery,
  PlatformQueryPagingMethodOneOf,
  Sorting,
  Paging,
  CursorPaging,
  QueryCategoriesResponse,
  PagingMetadataV2,
  Cursors,
  BulkDeleteCategoryRequest,
  BulkDeleteCategoryResponse,
  DeleteCategoryRequest,
  DeleteCategoryResponse,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  CategoryCreatedEnvelope,
  CategoryDeletedEnvelope,
  CategoryUpdatedEnvelope,
  CreateCategoryOptions,
  UpdateCategory,
  UpdateCategoryOptions,
  GetCategoryOptions,
  GetCategoryBySlugOptions,
  ListCategoriesOptions,
  QueryCategoriesOptions,
  CategoriesQueryResult,
  CategoriesQueryBuilder,
  CategoryQuerySpec,
} from './blog-v3-category-categories.universal.js';
export { utils } from './blog-v3-category-categories.universal.js';
export {
  FieldWithLiterals,
  SortOrderWithLiterals,
  WebhookIdentityTypeWithLiterals,
  CommonQueryWithEntityContext,
  CategoryQuery,
} from './blog-v3-category-categories.universal.js';
